<div class="row" style="width:100%; float: right; text-align: right; margin-top: 0px; padding-top: 0px; margin-right:0px !important"><div class="col-11"></div><div class="col-1 text-right" style="float:right; margin-right:0px; padding-right:0px;"><mat-icon style="float:right; cursor: pointer;" (click) = "onNoClick()">cancel</mat-icon></div></div>
<h1 mat-dialog-title>{{labels.lblEditTraining}}  "{{data.name}}" </h1>
<div mat-dialog-content>
  <form (ngSubmit)="onSubmit()" #editForm="ngForm" style="height: 435px">
    <div fxLayout="column">
      <input type="hidden" name="_id" [ngModel]="data._id">
      <mat-form-field appearance="fill" fxFlex="60%">
        <mat-label>{{labels.lblETrainingName}}</mat-label>
        <input matInput [ngModel]='data.name' name="name" required>
        @if (err == true) {
          <mat-error style="margin-bottom:1.5vh !important;">{{labels.lblfieldRequired}}</mat-error>
        }
      </mat-form-field>
      <mat-form-field class="matFormField" appearance="fill" fxFlex="60%">
        <textarea placeholder="{{labels.lblDescription}}" class="txtArea" maxlength = "600" rows = "5" cols = "5" matInput [ngModel]="data.description" name="description"></textarea>
        @if (err == true) {
          <!--<mat-error style="margin-bottom:1.5vh !important;">{{labels.lblfieldRequired}}</mat-error>-->
        }
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>{{labels.lblTrainer}}</mat-label>
        <mat-select [ngModel]='data.trainerId' name="trainerId" [disabled] = "assigned.length > 0" required>
          @for (trainer of trainers; track trainer) {
            <mat-option [value]="trainer._id">
              {{trainer.firstName}} {{trainer.lastName}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <!--<mat-form-field appearance="fill">
        <mat-label>{{labels.lblPriority}}</mat-label>
        <mat-select [ngModel]='data.priority' name="priority" [disabled] = "assigned.length > 0" required>
          <mat-option [value]="1">
            1
          </mat-option>
          <mat-option [value]="2">
            2
          </mat-option>
          <mat-option [value]="3">
            3
          </mat-option>
        </mat-select>
      </mat-form-field>-->
      <mat-form-field appearance="fill" fxFlex="60%">
        <mat-label>{{labels.lblTrainingTimeEstimation}}</mat-label>
        <input matInput pattern="[0-9]+" (input)="filterOnlyNumbers($event)" type="number"  name="duration" [(ngModel)]="duration" required/>
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>{{labels.lblAvailableAfterTraining}}</mat-label>
        <mat-select [ngModel]='data.availableAfterTraining' name="availableAfterTraining" [disabled] = "assigned.length > 0">
          <mat-option [value]="null">

          </mat-option>
          @for (training of otherTrainings; track training) {
            <mat-option [value]="training._id">
              {{ training.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{labels.lblDateLimit}}</mat-label>
        <input [(ngModel)]="data.toDate" name="toDate" matInput [matDatepicker]="toDate">
        <mat-hint>MM/DD/YYYY</mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="toDate"></mat-datepicker-toggle>
        <mat-datepicker #toDate></mat-datepicker>
      </mat-form-field>
      <div class="mat-form-field" style="display: flex; align-items: center; margin-bottom: 16px;">
        <mat-label style="margin-right: 16px;">{{labels.lblTurnOnAbleToSkip}}</mat-label>
        <mat-checkbox [(ngModel)]="ableToSkip" name="ableToSkip"
                      [checked]="ableToSkip" class="example-margin checkbox">
        </mat-checkbox>
      </div>
      <div class="mat-form-field" style="display: flex; align-items: center; margin-bottom: 16px;">
        <mat-label style="margin-right: 16px;">{{labels.lblAllowComments}}</mat-label>
        <mat-checkbox [(ngModel)]="allowComments" name="allowComments"
                      [checked]="allowComments" class="example-margin checkbox">
        </mat-checkbox>
      </div>
      @if (data.imagePath == null) {
        <mat-form-filed appearance="fill" fxFlex="60%">
          <input
            type="file"
            (input)="onImageChanged($event)"
            #imageUpload
            style="display: none;"
            >
          <button mat-raised-button type="button" class="noBtn" (click)="imageUpload.click()" [disabled] = "assigned.length > 0">{{labels.lblUploadImage}}</button>
          <!-- <mat-label *ngIf="selectedImage">
          {{selectedImage.name}}
        </mat-label> -->
      </mat-form-filed>
    }
    @if (data.imagePath != null) {
      <div>
        <mat-label>{{labels.lblImage}}: {{data.imageName}}</mat-label>
        <mat-icon style="float:right; cursor: pointer;" (click)="updateData()" [class.disabled-icon] = "assigned.length > 0">cancel</mat-icon>
      </div>
    }
    @if (data.trngInfoImagePath == null) {
      <mat-form-filed appearance="fill" fxFlex="60%">
        <input
          type="file"
          (input)="onCoverImageChanged($event)"
          #imageUpload2
          style="display: none;"
          >
        <button mat-raised-button type="button" class="noBtn" (click)="imageUpload2.click()" [disabled] = "assigned.length > 0">{{labels.lblUploadCoverImage}}</button>
        <!-- <mat-label *ngIf="selectedImage">
        {{selectedImage.name}}
      </mat-label> -->
    </mat-form-filed>
  }
  @if (data.trngInfoImagePath != null) {
    <div>
      <mat-label>Naslovna {{labels.lblImage}}: {{data.coverImageName}}</mat-label>
      <mat-icon style="float:right; cursor: pointer;" (click)="updateCoverData()" [class.disabled-icon] = "assigned.length > 0">cancel</mat-icon>
    </div>
  }

  <div mat-dialog-actions>
    @if (uploading) {
      <mat-progress-bar mode="indeterminate" style="margin-top: 15px;"></mat-progress-bar>
    }
    <!-- <button class="noBtn" mat-button (click)="onNoClick()" type="button">{{labels.lblNo}}</button> -->
    <button class="btn" cdkFocusInitial type="submit"  style="margin-top: 15px;">{{labels.lblSave}}</button>
  </div>
</div>
</form>
</div>


